import { render, staticRenderFns } from "./order-product-select.vue?vue&type=template&id=49d769f3&"
import script from "./order-product-select.vue?vue&type=script&lang=js&"
export * from "./order-product-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports